document.addEventListener('DOMContentLoaded', function () {

  const modal =
    document.getElementById('KryptoniteAuthModal');

  if (!modal) return;


  const loginPanel =
    modal.querySelector(
      '[data-auth-panel="login"]'
    );

  const registerPanel =
    modal.querySelector(
      '[data-auth-panel="register"]'
    );


  /* =========================================
     OPEN
  ========================================== */

  function openAuth(mode) {

    modal.classList.add('is-open');

    modal.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.classList.add(
      'kr-auth-open'
    );

    showPanel(mode || 'login');

  }


  /* =========================================
     CLOSE
  ========================================== */

  function closeAuth() {

    modal.classList.remove('is-open');

    modal.setAttribute(
      'aria-hidden',
      'true'
    );

    document.body.classList.remove(
      'kr-auth-open'
    );

  }


  /* =========================================
     SWITCH PANEL
  ========================================== */

  function showPanel(mode) {

    if (mode === 'register') {

      loginPanel.hidden = true;

      registerPanel.hidden = false;

    } else {

      registerPanel.hidden = true;

      loginPanel.hidden = false;

    }

  }


  /* =========================================
     OPEN BUTTON
  ========================================== */

  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          '[data-auth-open]'
        );

      if (!button) return;

      event.preventDefault();

      openAuth('login');

    }
  );


  /* =========================================
     CLOSE BUTTON
  ========================================== */

  modal.addEventListener(
    'click',
    function (event) {

      if (
        event.target === modal ||
        event.target.closest('[data-auth-close]')
      ) {

        closeAuth();

      }

    }
  );


  /* =========================================
     REGISTER
  ========================================== */

  document.addEventListener(
    'click',
    function (event) {

      if (
        !event.target.closest(
          '[data-show-register]'
        )
      ) return;

      showPanel('register');

    }
  );


  /* =========================================
     LOGIN
  ========================================== */

  document.addEventListener(
    'click',
    function (event) {

      if (
        !event.target.closest(
          '[data-show-login]'
        )
      ) return;

      showPanel('login');

    }
  );


  /* =========================================
     ESCAPE
  ========================================== */

  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape' &&
        modal.classList.contains('is-open')
      ) {

        closeAuth();

      }

    }
  );


  /* =========================================
     PASSWORD SHOW / HIDE
  ========================================== */

  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          '[data-password-toggle]'
        );

      if (!button) return;


      const selector =
        button.getAttribute(
          'data-password-toggle'
        );


      const input =
        document.querySelector(selector);

      if (!input) return;


      if (input.type === 'password') {

        input.type = 'text';

        button.textContent = 'HIDE';

      } else {

        input.type = 'password';

        button.textContent = 'SHOW';

      }

    }
  );


  /* =========================================
     EMAIL VALIDATION
  ========================================== */

  function validEmail(email) {

    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i
      .test(email.trim());

  }


  /* LOGIN VALIDATION */

  const loginForm =
    loginPanel.querySelector('form');

  if (loginForm) {

    loginForm.addEventListener(
      'submit',
      function (event) {

        const email =
          document.getElementById(
            'KRLoginEmail'
          );

        const error =
          loginPanel.querySelector(
            '[data-login-email-error]'
          );


        if (
          !validEmail(email.value)
        ) {

          event.preventDefault();

          error.textContent =
            'Please enter a valid email address.';

          email.focus();

        } else {

          error.textContent = '';

        }

      }
    );

  }


  /* =========================================
     REGISTER VALIDATION
  ========================================== */

  const registerForm =
    registerPanel.querySelector('form');

  if (registerForm) {

    registerForm.addEventListener(
      'submit',
      function (event) {

        let valid = true;


        const email =
          document.getElementById(
            'KRRegisterEmail'
          );

        const emailError =
          registerPanel.querySelector(
            '[data-register-email-error]'
          );


        const password =
          document.getElementById(
            'KRRegisterPassword'
          );

        const confirmPassword =
          document.getElementById(
            'KRConfirmPassword'
          );

        const passwordError =
          registerPanel.querySelector(
            '[data-password-error]'
          );


        /* EMAIL */

        if (
          !validEmail(email.value)
        ) {

          emailError.textContent =
            'Please enter a valid email address.';

          valid = false;

        } else {

          emailError.textContent = '';

        }


        /* PASSWORD */

        if (
          password.value.length < 5
        ) {

          passwordError.textContent =
            'Password must contain at least 5 characters.';

          valid = false;

        }


        /* PASSWORD MATCH */

        else if (
          password.value !==
          confirmPassword.value
        ) {

          passwordError.textContent =
            'Passwords do not match.';

          valid = false;

        }

        else {

          passwordError.textContent = '';

        }


        if (!valid) {

          event.preventDefault();

        }

      }
    );

  }

});